<script>
import IconFactory from "@js/components/Icons/IconFactory.vue";
import IconDeliveryCar from "@js/components/Icons/IconDeliveryCar.vue";
import IconStar from "@js/components/Icons/IconStar.vue";
import IconCertificate from "@js/components/Icons/IconCertificate.vue";
import IconBox from "@js/components/Icons/IconBox.vue";
import IconCircleShare from "@js/components/Icons/IconCircleShare.vue";

export default {
    name: "CompanyAdvantages",
    components: {IconCircleShare, IconBox, IconCertificate, IconStar, IconDeliveryCar, IconFactory}
}
</script>

<template>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-10 mb-8">
        <div class="flex items-center gap-5 text-sm">
            <IconFactory class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Плитка от производителя
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Поставки напрямую с заводов. Без посредников и переплат. Гарантия качества и выгодные цены.
                </p>
            </div>
        </div>
        <div class="flex items-center gap-5 text-sm">
            <IconBox class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Быстрая доставка
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Отправляем в день заказа или на следующий день. Работаем с надёжными транспортными компаниями.
                </p>
            </div>
        </div>
        <div class="flex items-center gap-5 text-sm">
            <IconCircleShare class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Отслеживание заказа
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Каждому заказу присваивается трек-номер. Вы всегда знаете, где находится ваш товар и когда он
                    прибудет.
                </p>
            </div>
        </div>
        <div class="flex items-center gap-5 text-sm">
            <IconCertificate class="min-w-[35px] max-h-[35px] min-h-[35px] max-w-[35px]"/>
            <div>
                <p class="font-bold">
                    Гарантии
                </p>
                <p class="text-gray-500 text-xs font-medium">
                    Официальная гарантия на всю продукцию. В случае брака — быстрый возврат или замена без лишних
                    формальностей.
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
